import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import { UPDATE_CUSTOMER_SERVICE } from './type';

import RootState from '../../state';

export default class CustomerServiceModule implements Module<object, RootState> {
    state: object;

    getters: GetterTree<object, RootState> = {
        customerService(state): any {
            return state.customerService;
        },
    };

    actions: ActionTree<object, RootState> = {
        async updateCustomerService({ commit, dispatch, state, rootState }, payload) {
            commit(UPDATE_CUSTOMER_SERVICE, payload);
        },
    };

    mutations: MutationTree<object> = {
        [UPDATE_CUSTOMER_SERVICE](state, payload) {
            state.customerService = {
                ...state.customerService,
                ...payload,
            };
        },
    };

    constructor(initState: object) {
        this.state = {
            defaultValue: '',
            ...initState,
        };
    }
}